import { render } from "./FieldChoice.vue?vue&type=template&id=5d7aa19a"
import script from "./FieldChoice.vue?vue&type=script&lang=js"
export * from "./FieldChoice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__